var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.269 4.723a.7.7 0 0 0-.131-.196l-4-4a.7.7 0 0 0-.195-.13Q6.913.384 6.88.375A.7.7 0 0 0 6.707.34c-.014-.002-.026-.009-.04-.009H2C1.265.332.667.93.667 1.665v10.667c0 .735.597 1.333 1.333 1.333h8c.735 0 1.333-.598 1.333-1.333V4.999c0-.014-.007-.027-.008-.042a.6.6 0 0 0-.034-.172q-.01-.032-.023-.062m-2.212-.391H7.333V2.608zm-7.057 8V1.665h4V5a.667.667 0 0 0 .667.666H10L10 12.332z"
  })));
};
export default SvgAttach;